/* Nordik LP — motion layer
 * Jakub-weighted production polish: subtle, fast, purposeful. Emil restraint on nav/forms.
 * Everything degrades to static under prefers-reduced-motion.
 */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Scroll reveal (opacity + translateY + blur), staggered by --i ----
   * Activate hiding ONLY now that JS is running. The CSS hide rule is gated behind
   * .reveal-on, so if this script never loads, every section stays visible. */
  document.querySelectorAll('.nordik-lp').forEach(function (root) { root.classList.add('reveal-on'); });
  var revealEls = document.querySelectorAll('.reveal');
  if (reduce || !('IntersectionObserver' in window)) {
    revealEls.forEach(function (el) { el.classList.add('in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  }

  /* Theme editor re-injects sections via shopify:section:load AFTER this script ran,
   * so their .reveal elements would never get observed and would stay at opacity:0.
   * Reveal injected content immediately (no scroll animation needed inside the editor). */
  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target || !e.target.querySelectorAll) return;
    e.target.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
  });

  /* ---- Hero glow + product parallax (transform only, rAF-throttled) ---- */
  if (!reduce) {
    var product = document.querySelector('[data-parallax]');
    var glow = document.querySelector('.hero__glow');
    if (product || glow) {
      var ticking = false;
      var onScroll = function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var y = window.scrollY;
          if (y < window.innerHeight) {
            if (product) product.style.transform = 'translateY(' + (y * 0.06) + 'px)';
            if (glow) glow.style.transform = 'translateY(' + (y * 0.12) + 'px)';
          }
          ticking = false;
        });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  }

  /* ---- Count-up for the 4.8 rating ---- */
  var counters = document.querySelectorAll('[data-count]');
  counters.forEach(function (el) {
    var target = parseFloat(el.getAttribute('data-count'));
    if (reduce || !('IntersectionObserver' in window)) { el.textContent = target.toFixed(1); return; }
    var done = false;
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && !done) {
          done = true;
          var start = null, dur = 1100;
          var step = function (ts) {
            if (!start) start = ts;
            var p = Math.min((ts - start) / dur, 1);
            var eased = 1 - Math.pow(1 - p, 3);
            el.textContent = (target * eased).toFixed(1);
            if (p < 1) requestAnimationFrame(step);
          };
          requestAnimationFrame(step);
          cio.unobserve(el);
        }
      });
    }, { threshold: 0.6 });
    cio.observe(el);
  });

  /* ---- Sticky mobile buy bar: reveal after hero scrolls past ---- */
  var bar = document.querySelector('.buybar');
  if (bar) {
    var hero = document.querySelector('.hero');
    var trigger = hero ? hero.offsetHeight * 0.8 : 600;
    var barTick = false;
    var barScroll = function () {
      if (barTick) return; barTick = true;
      requestAnimationFrame(function () {
        if (window.scrollY > trigger) bar.classList.add('show');
        else bar.classList.remove('show');
        barTick = false;
      });
    };
    window.addEventListener('scroll', barScroll, { passive: true });
  }

  /* ---- Ticker: duplicate items so the marquee loops seamlessly ---- */
  var track = document.querySelector('.ticker__track');
  if (track && !reduce) {
    track.innerHTML += track.innerHTML;
  }

  /* ---- Klaviyo email capture — FUNCTIONALITY ONLY ----
   * Fill these two IDs from the brand's Klaviyo account (leave blank = demo mode):
   *   KLAVIYO_COMPANY_ID -> public API key / company ID  (used as ?company_id=)
   *   KLAVIYO_LIST_ID    -> the list the email is added to (relationships.list.data.id)
   */
  var KLAVIYO_COMPANY_ID = ""; // <-- attach later
  var KLAVIYO_LIST_ID    = ""; // <-- attach later

  function kvStatus(form, msg, ok) {
    var el = form.parentNode ? form.parentNode.querySelector('[data-klaviyo-status]') : null;
    if (el) { el.textContent = msg; el.style.color = ok ? 'var(--accent-2)' : 'var(--warn)'; }
  }

  document.querySelectorAll('[data-klaviyo-spec-sheet]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input[type=email]');
      var email = input ? input.value.trim() : '';
      // IDs can come from the form's data- attributes (Shopify section settings) or the consts above.
      var companyId = form.getAttribute('data-klaviyo-company') || KLAVIYO_COMPANY_ID;
      var listId = form.getAttribute('data-klaviyo-list') || KLAVIYO_LIST_ID;
      if (!email) { kvStatus(form, 'Please enter your email address.', false); return; }
      if (!companyId || !listId) {
        // Demo mode until IDs are attached — no network call.
        kvStatus(form, 'Thanks! (Klaviyo IDs not yet connected.)', true); form.reset(); return;
      }
      kvStatus(form, 'Sending…', true);
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + companyId, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: { profile: { data: { type: 'profile', attributes: { email: email } } } },
            relationships: { list: { data: { type: 'list', id: listId } } }
          }
        })
      }).then(function (res) {
        if (res.status === 202) { kvStatus(form, 'Done — your spec sheet is on its way.', true); form.reset(); }
        else { kvStatus(form, 'Something went wrong. Please try again.', false); }
      }).catch(function () { kvStatus(form, 'Network error. Please try again.', false); });
    });
  });
})();


/* ============ SIZE SWITCHER ============ */
(function () {
  function bindSwitchers(scope) {
    (scope || document).querySelectorAll('.nordik-lp .switcher').forEach(function (sw) {
      if (sw.dataset.swReady === '1') return; sw.dataset.swReady = '1';
      sw.querySelectorAll('.sw-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var i = btn.getAttribute('data-i');
          sw.querySelectorAll('.sw-btn, .sw-slide, .sw-detail').forEach(function (el) {
            el.classList.toggle('is-active', el.getAttribute('data-i') === i);
          });
        });
      });
    });
  }
  bindSwitchers(document);
  document.addEventListener('shopify:section:load', function (e) { bindSwitchers(e.target); });
})();


/* ============ TABS ============ */
(function () {
  function bindTabs(scope) {
    (scope || document).querySelectorAll('.nordik-lp .tabs').forEach(function (t) {
      if (t.dataset.tabReady === '1') return; t.dataset.tabReady = '1';
      t.querySelectorAll('.tab-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var i = btn.getAttribute('data-tab');
          t.querySelectorAll('.tab-btn, .tab-panel').forEach(function (el) {
            el.classList.toggle('is-active', el.getAttribute('data-tab') === i);
          });
        });
      });
    });
  }
  bindTabs(document);
  document.addEventListener('shopify:section:load', function (e) { bindTabs(e.target); });
})();
